// extracted by mini-css-extract-plugin
module.exports = {"amenities__item":"amenities__item-Eama7","amenities__item_unavailable":"amenities__item_unavailable-3JOOa"};